

import Routes from "./routes/routes";
import {Provider} from 'react-redux';
import React, { useEffect } from 'react';
import PersistedStore from "./store";
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import './App.css'
import './helper.css'
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import { TRACKING_ID,PIXEL_ID,GTM_ID} from './environment/index.js';
import TagManager from 'react-gtm-module';

ReactGA.initialize(TRACKING_ID);
// ReactPixel.init(PIXEL_ID);
const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif'
    // fontFamily: 'Flexo'
  },});
const store = PersistedStore.getDefaultStore().store;

const App = () => {
  useEffect(() => {
    const options = {
      autoConfig: true, // Automatic configuration of the Pixel
      debug: true,      // Debug mode to log events to the console
    };
    const tagManagerArgs = {
      gtmId: GTM_ID, 
    };
    TagManager.initialize(tagManagerArgs);
    ReactPixel.init(PIXEL_ID, null, options);
    ReactPixel.pageView();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Routes/>
      </Provider>
    </ThemeProvider>
)}

export default App;

// https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#.YbD42UeP0l4.linkedin
